import { render, staticRenderFns } from "./InAppStoreMenu.vue?vue&type=template&id=407d2bcf&scoped=true"
import script from "./InAppStoreMenu.vue?vue&type=script&lang=js"
export * from "./InAppStoreMenu.vue?vue&type=script&lang=js"
import style0 from "./InAppStoreMenu.vue?vue&type=style&index=0&id=407d2bcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407d2bcf",
  null
  
)

export default component.exports